import React from "react";
import { Heart, BookOpen, CheckCircle2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

const OPTIONS = [
  { key: "favourite", label: "Favourite", icon: Heart },
  { key: "learning", label: "Learning", icon: BookOpen },
  { key: "know_it", label: "Know It", icon: CheckCircle2 },
];

export function PersonalControls({ dance, statuses = [], onChange, size = "md" }) {
  const { user } = useAuth();
  const navigate = useNavigate();

  const toggle = async (key) => {
    if (!user) {
      toast("Please log in to save dances", { description: "Create a free account to build your personal dance library." });
      navigate("/login", { state: { from: `/dances/${dance.slug}` } });
      return;
    }
    const next = statuses.includes(key)
      ? statuses.filter((s) => s !== key)
      : [...statuses, key].filter((s) => {
          if (key === "learning") return s !== "know_it";
          if (key === "know_it") return s !== "learning";
          return true;
        });
    try {
      await api.post("/me/dances", { dance_id: dance.id, statuses: next });
      onChange?.(next);
      toast.success(next.includes(key) ? `Marked as ${OPTIONS.find((o) => o.key === key).label}` : "Removed");
    } catch {
      toast.error("Could not update. Please try again.");
    }
  };

  const pad = size === "sm" ? "px-2.5 py-1.5 text-xs" : "px-3.5 py-2 text-sm";
  return (
    <div className="flex flex-wrap gap-2" data-testid="personal-controls">
      {OPTIONS.map(({ key, label, icon: Icon }) => {
        const active = statuses.includes(key);
        return (
          <button key={key} data-testid={`dance-status-${key}`} onClick={() => toggle(key)}
            aria-pressed={active} aria-label={`${active ? "Remove" : "Add"} ${label}`}
            className={`inline-flex items-center gap-1.5 rounded-full border font-semibold transition ${pad} ${
              active
                ? "bg-[#C85A32] border-[#C85A32] text-white shadow-sm"
                : "bg-white border-border text-[#5C4A42] hover:border-[#C85A32] hover:text-[#B04B26]"
            }`}>
            <Icon size={size === "sm" ? 14 : 16} fill={active && key === "favourite" ? "currentColor" : "none"} />
            {label}
          </button>
        );
      })}
    </div>
  );
}
